import React from 'react';
import Marquee from 'react-fast-marquee';

const About = ({ personalData, skillsData }) => {
  return (
    <section id="about" className="w-full" data-aos="fade-up">

      {/* Section Header */}
      <div className="text-center mb-12">
        <p className="section-eyebrow">Get to know me</p>
        <h2 className="section-heading">About Me</h2>
        <div className="section-divider" />
      </div>

      {/* Bio + Photo */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">

        {/* Bio text */}
        <div data-aos="fade-right">
          <div className="space-y-4">
            {personalData.description.split('\n\n').map((paragraph, i) => (
              <p key={i} className="dark:text-slate-300 text-slate-700 leading-relaxed text-sm md:text-base">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Profile photo placeholder */}
        <div className="flex justify-center" data-aos="fade-left">
          <div className="relative">
            {/* Glow ring */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600
              rounded-2xl blur-2xl opacity-25 scale-110 pointer-events-none" />
            <img
              src={personalData.profile}
              alt={personalData.name}
              className="relative rounded-2xl w-64 h-80 object-cover object-top
                dark:border border dark:border-slate-700/50 border-slate-200
                hover:scale-105 transition-transform duration-500"
            />
          </div>
        </div>
      </div>

      {/* Skills Marquee */}
      {skillsData && (
        <div data-aos="fade-up" data-aos-delay="200">
          <p className="text-center dark:text-slate-400 text-slate-500 text-xs uppercase tracking-widest mb-6">
            Technologies &amp; Tools
          </p>
          <Marquee gradient={false} speed={60} pauseOnHover={true}>
            {skillsData.map(skill => (
              <div
                key={skill.name}
                className="mx-3 flex flex-col items-center gap-2 px-5 py-4 rounded-xl
                  dark:border border dark:border-slate-700/50 border-slate-200
                  dark:bg-[#0e0c29] bg-white
                  dark:hover:border-blue-500/50 hover:border-blue-400/50
                  dark:hover:bg-blue-500/5 hover:bg-blue-50
                  transition-all duration-300 min-w-[100px]"
              >
                <img src={skill.icon} alt={skill.name} className="h-8 w-8" loading="lazy" />
                <span className="text-xs dark:text-slate-400 text-slate-600 font-medium">{skill.name}</span>
              </div>
            ))}
          </Marquee>
        </div>
      )}

    </section>
  );
};

export default About;
